import * as _ from "lodash";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import actions from "@/actions";

import Panel from "../base/Panel";
import PanelButtons from "./panel-buttons";

const SelectPanel = ({ changeMapMode }) => {
    return (
        <Panel title="Selection Type">
            {_.map(PanelButtons, (Button, name) => (
                <Button
                    key={`select-type-${name}`}
                    color="#FFF"
                    title={name}
                    className="tools-bar-button"
                    onClick={() => changeMapMode("select", { type: name })}
                />
            ))}
        </Panel>
    );
};

SelectPanel.propTypes = {
    changeMapMode: PropTypes.func.isRequired,
};

const mapStateToProps = () => ({});
const mapDispatchToProps = {
    changeMapMode: actions.map.general.changeMode,
};
export default connect(mapStateToProps, mapDispatchToProps)(SelectPanel);
